export default {"src":"/_next/static/media/pw.d77dd440.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};